import { Rich } from '@/components/Rich'
import type { ChallengeWeek } from '@/domain/workout'
import { workoutDuration } from '@/domain/timeline'
import { cx } from '@/lib/cx'
import { minutes } from '@/lib/format'
import styles from './panel.module.css'

interface WeekPosterProps {
  week: ChallengeWeek
  totalWeeks: number
}

/** El cartel de la semana: lo primero que se ve al abrir la app. */
export function WeekPoster({ week, totalWeeks }: WeekPosterProps) {
  const duration = minutes(workoutDuration(week.workout))

  return (
    <header className={styles.poster}>
      <div className={cx(styles.posterMeta, 'mono')}>
        <span>
          Semana {String(week.number).padStart(2, '0')} / {String(totalWeeks).padStart(2, '0')}
        </span>
        <span>{week.dateLabel}</span>
      </div>

      <h1 className={styles.title}>
        {week.title.lead}
        {week.title.lead && <br />}
        <em>{week.title.accent}</em>
      </h1>

      <dl className={styles.sheet}>
        <div>
          <dt>Bloque</dt>
          <dd>{week.blockLabel}</dd>
        </div>
        <div>
          <dt>Duración</dt>
          <dd>±{duration} min</dd>
        </div>
        <div>
          <dt>Material</dt>
          <dd>Ninguno</dd>
        </div>
      </dl>

      <p className={styles.intro}>
        <Rich parts={week.intro} />
      </p>
    </header>
  )
}
